module.exports = __webpack_public_path__ + "7f1b04773541195a74c033a344441517.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/cape-stars.png
// module id = 1866
// module chunks = 0